import React, { useState, useRef, useEffect, useContext } from 'react';
import { LoadingContext } from "react-router-loading";
import { Row } from 'antd';
import axios from "axios";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { TokenVerificationLoggedin, BlockAdmin, BlockAM } from "../../utils/tokenVerify";
import configData from "../../config/config.json";
import { Table, Radio, Select, Col, Input, Button, Tooltip } from 'antd';
import Dropdown from 'react-bootstrap/Dropdown';
import errorData from '../../assets/images/data-graph/error-data.svg';
import noData from '../../assets/images/data-graph/no-data.svg';
import FullLoader from "../../assets/images/full-page-loader.gif";
import { notifysuccess, notifyfailure, notifycatch } from "../../utils/toast";
import { Link } from 'react-router-dom';
import TableLoader from '../TableLoader';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";
import alertDanger from '../../assets/images/icons/alert-danger.svg';
import uploadIcon from '../../assets/images/icons/upload-cloud.svg';
import deleteIcon from '../../assets/images/icons/trash.svg';
import downloadCsvIcon from '../../assets/images/icons/download_csv_icon.svg';
import loaderIcon from "../../assets/images/login-and-signup/loader.gif";
import FileIcon from '../../assets/images/icons/offcanva_file_icon.svg';

const UprMapper = () => {
    const loadingContext = useContext(LoadingContext);
    const [/* checkRole */, setCheckRole] = useState("admin");
    const [loading, setLoading] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [initialLoad, setInitialLoad] = useState(true);
    const [uploadShow, setUploadShow] = useState(false);
    // Holds the validated file ({ data, filename, size }) until it's submitted.
    const [selectedFile, setSelectedFile] = useState(null);
    const tableWrapperRef = useRef(null);
    const uploadDropdownRef = useRef(null);

    const notifyfailure2 = (msg) => toast.error(
        <>
            <img src={alertDanger} alt="" className="me_12" />
            <span className="text">{msg}</span>
        </>,
        {
            autoClose: 4000, position: "top-center"
        });

    useEffect(() => {
        TokenVerificationLoggedin();
        BlockAdmin();
        BlockAM();
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            let checkRole = jwtDecode(token).role;
            setCheckRole(checkRole);
        }

        getData()
        loadingContext.done();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingContext]);

    // While the upload dropdown is open, an outside click shakes it (like Tagging)
    // instead of closing — the user must use Discard / Submit.
    useEffect(() => {
        function handleClickOutsideUpload(event) {
            if (
                uploadDropdownRef.current &&
                !uploadDropdownRef.current.contains(event.target) &&
                uploadShow
            ) {
                const shakeDiv = document.getElementById("uprUploadShake");
                if (shakeDiv && !shakeDiv.contains(event.target)) {
                    shakeDiv.classList.add("shake");
                    setTimeout(() => shakeDiv.classList.remove("shake"), 500);
                }
            }
        }
        document.addEventListener("mousedown", handleClickOutsideUpload);
        return () => document.removeEventListener("mousedown", handleClickOutsideUpload);
    });

    /* ---------------------------------------------------------------------------------------
     * TABS
     * ------------------------------------------------------------------------------------- */
    const [tab, setTab] = useState("live");
    function handleTabChange(event) {
        setTab(event.target.value);
        setSearchText("");
        setInitialLoad(true);

        getData()

    }

    /* ---------------------------------------------------------------------------------------
     * DATA (currently sample — API wiring is commented out below)
     * ------------------------------------------------------------------------------------- */
    const [dataSource, setDataSource] = useState([]);
    // eslint-disable-next-line no-unused-vars
    const [dataSourceHistory, setDataSourceHistory] = useState([]);

    // Map an API record into the shape the table rows use.
    // `isActive` true => "enabled", false => "archived".
    const mapItem = (item) => ({
        key: item._id,
        id: item._id,
        status: item.isActive ? "enabled" : "archived",
        uprId: item.upr_id,
        uprName: item.upr_name,
        placementId: item.placementId,
        placementName: item.placementName,
        zone: item.zoneCount,
        zoneIds: item.zoneIds,
        configuredAmount: item.configured_amount_gbp,
        expectedAmount: item.expected_amount_usd,
        variance: item.variance,
        isNewRow: false,
        isEditing: false,
        originalRow: null,
        errors: {}
    });


    const getData = () => {
        setLoading(true);
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            axios
                .get(configData.SERVER_URL + `upr-placement/all`, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    setDataSource(
                        response.data.data?.length > 0
                            ?
                            response.data.data.map(mapItem)
                            : []
                    );
                    setLoading(false);
                    setInitialLoad(false);
                })
                .catch(() => {
                    setDataSource([]);
                    setLoading(false);
                    setInitialLoad(false);
                });
        }
    };

    /* ---------------------------------------------------------------------------------------
     * VALIDATION
     * ------------------------------------------------------------------------------------- */
    // UPR ID / Placement ID must be digits only (kept as strings in the payload).
    const isNumericString = value => /^\d+$/.test(value?.toString().trim());

    // Keep only digits and a single decimal point while typing an amount.
    const sanitizeAmount = value => {
        const cleaned = value.replace(/[^\d.]/g, "");
        const parts = cleaned.split(".");
        return parts.length > 2 ? `${parts[0]}.${parts.slice(1).join("")}` : cleaned;
    };

    // Amounts may be whole or decimal and must be greater than 0.
    const isPositiveAmount = value => {
        const str = value?.toString().trim();
        if (!/^\d*\.?\d+$/.test(str)) return false;
        return parseFloat(str) > 0;
    };

    const validateRow = row => {
        const errors = {};
        if (!row.uprId?.toString().trim()) errors.uprId = "UPR ID is required";
        else if (!isNumericString(row.uprId)) errors.uprId = "UPR ID must be a number";
        if (!row.uprName?.toString().trim()) errors.uprName = "UPR Name is required";
        if (!row.placementId?.toString().trim()) errors.placementId = "Placement ID is required";
        else if (!isNumericString(row.placementId)) errors.placementId = "Placement ID must be a number";
        if (!row.placementName?.toString().trim()) errors.placementName = "Placement Name is required";
        if (!row.configuredAmount?.toString().trim()) errors.configuredAmount = "Configured amount is required";
        else if (!isPositiveAmount(row.configuredAmount)) errors.configuredAmount = "Configured amount must be a number greater than 0";
        if (!row.expectedAmount?.toString().trim()) errors.expectedAmount = "Expected amount is required";
        else if (!isPositiveAmount(row.expectedAmount)) errors.expectedAmount = "Expected amount must be a number greater than 0";
        return errors;
    };

    const isRowValid = row =>
        !row.errors || Object.keys(row.errors).length === 0;

    /* ---------------------------------------------------------------------------------------
     * ROW HELPERS
     * ------------------------------------------------------------------------------------- */
    const isSameValue = (a, b) => (a ?? "").toString() === (b ?? "").toString();

    const hasRowChanged = (row) => {
        if (!row.originalRow) return false;
        // Only the editable payload keys count as a change (status is
        // handled independently, zone/variance are computed server-side).
        return (
            !isSameValue(row.uprId, row.originalRow.uprId) ||
            !isSameValue(row.uprName, row.originalRow.uprName) ||
            !isSameValue(row.placementId, row.originalRow.placementId) ||
            !isSameValue(row.placementName, row.originalRow.placementName) ||
            !isSameValue(row.configuredAmount, row.originalRow.configuredAmount) ||
            !isSameValue(row.expectedAmount, row.originalRow.expectedAmount)
        );
    };

    const handleChange = (key, field, value) => {
        setDataSource(prev =>
            prev.map(row => {
                if (row.key !== key) return row;

                const baseOriginal =
                    row.originalRow ??
                    (!row.isEditing && !row.isNewRow ? { ...row } : null);

                const updatedRow = {
                    ...row,
                    [field]: value,
                    originalRow: baseOriginal,
                };

                const changed = hasRowChanged({ ...updatedRow, originalRow: baseOriginal });

                return {
                    ...updatedRow,
                    isEditing: row.isNewRow ? true : changed,
                    errors: validateRow(updatedRow),
                };
            })
        );
    };

    /* ---------------------------------------------------------------------------------------
     * ADD / EDIT / SAVE / CANCEL
     * ------------------------------------------------------------------------------------- */
    const hasNewRow = dataSource.some(row => row.isNewRow);

    // Close any open edit/new row, discarding its unsaved changes.
    // Only one row can be edited/added at a time.
    const revertEditingRows = (rows) =>
        rows
            .map(row => {
                if (row.isNewRow) return null; // drop unsaved new rows
                if (row.isEditing) {
                    return {
                        ...(row.originalRow ?? row),
                        isEditing: false,
                        originalRow: null,
                        errors: {}
                    };
                }
                return row;
            })
            .filter(Boolean);

    const handleAddMore = () => {
        if (hasNewRow) return;

        setDataSource(prev => [
            ...revertEditingRows(prev),
            {
                key: Date.now(),
                id: null,
                status: "enabled",
                uprId: "",
                uprName: "",
                placementId: "",
                placementName: "",
                zone: "",
                configuredAmount: "",
                expectedAmount: "",
                variance: "",
                isNewRow: true,
                isEditing: true,
                originalRow: null,
                errors: {
                    uprId: "UPR ID is required",
                    uprName: "UPR Name is required",
                    placementId: "Placement ID is required",
                    placementName: "Placement Name is required",
                    configuredAmount: "Configured amount is required",
                    expectedAmount: "Expected amount is required"
                }
            }
        ]);

        setTimeout(() => {
            const tableBody = tableWrapperRef.current?.querySelector(".ant-table-body");
            if (tableBody) {
                tableBody.scrollTo({ top: tableBody.scrollHeight, behavior: "smooth" });
            }
        }, 0);
    };

    const handleEdit = (key) => {
        setDataSource(prev =>
            // Close any other open edit first, then open this one.
            revertEditingRows(prev).map(row =>
                row.key === key
                    ? { ...row, isEditing: true, originalRow: { ...row } }
                    : row
            )
        );
    };

    const handleSave = (key) => {
        const rowToSave = dataSource.find(r => r.key === key);
        if (!rowToSave) return;

        if (!isRowValid(rowToSave)) {
            notifyfailure("Please fill all required fields before saving.");
            return;
        }

        // ✅ Unique UPR ID check against other saved rows
        const isDuplicateId = dataSource.some(
            row =>
                row.key !== key &&
                !row.isNewRow &&
                row.uprId?.toString().trim() === rowToSave.uprId?.toString().trim()
        );

        if (isDuplicateId) {
            notifyfailure(`UPR ID "${rowToSave.uprId}" already exists. Please use a unique UPR ID.`);
            return;
        }

        const token = Cookies.get("token_xapads_ssp");
        const headers = { "Content-Type": "application/json", "x-access-token": token };

        // Only the keys the API accepts — nothing else is sent.
        // IDs and amounts are sent as strings.
        const payload = {
            upr_id: rowToSave.uprId?.toString(),
            upr_name: rowToSave.uprName,
            configured_amount_gbp: rowToSave.configuredAmount?.toString(),
            expected_amount_usd: rowToSave.expectedAmount?.toString(),
            placementId: rowToSave.placementId?.toString(),
            placementName: rowToSave.placementName,
        };

        setLoading(true);

        const request = rowToSave.isNewRow
            ? axios.post(configData.SERVER_URL + `upr-placement`, payload, { headers })
            : axios.put(configData.SERVER_URL + `upr-placement/${rowToSave.id}`, payload, { headers });

        request
            .then((response) => {
                notifysuccess(response.data.message);
                getData();
            })
            .catch((error) => {
                setLoading(false);
                if (error?.response?.data?.message) notifyfailure(error.response.data.message);
                else notifycatch();
            });
    };

    const handleCancel = (key) => {
        setDataSource(prev =>
            prev.map(row => {
                if (row.key !== key) return row;
                if (row.isNewRow) return null; // drop unsaved new rows
                return {
                    ...(row.originalRow ?? row),
                    isEditing: false,
                    originalRow: null,
                    errors: {}
                };
            }).filter(Boolean)
        );
    };

    // Status change is independent of edit — it persists on its own via PATCH.
    // "enabled" => isActive true, "archived" => isActive false.
    const handleChangeStatus = (record, value) => {
        if (value === record.status) return;

        const previousStatus = record.status;
        const token = Cookies.get("token_xapads_ssp");
        const headers = { "Content-Type": "application/json", "x-access-token": token };

        // Optimistic update.
        setDataSource(prev =>
            prev.map(row =>
                row.key === record.key ? { ...row, status: value } : row
            )
        );

        axios
            .patch(
                configData.SERVER_URL + `upr-placement/${record.id}/status`,
                { isActive: value === "enabled" },
                { headers }
            )
            .then((response) => {
                notifysuccess(response.data.message);
            })
            .catch((error) => {
                // Revert on failure.
                setDataSource(prev =>
                    prev.map(row =>
                        row.key === record.key ? { ...row, status: previousStatus } : row
                    )
                );
                if (error?.response?.data?.message) notifyfailure(error.response.data.message);
                else notifycatch();
            });
    };

    /* ---------------------------------------------------------------------------------------
     * SEARCH + SUMMARY
     * ------------------------------------------------------------------------------------- */
    const [searchText, setSearchText] = useState("");

    const filteredDataSource = React.useMemo(() => {
        const query = searchText.trim().toLowerCase();

        const searched = !query
            ? dataSource
            : dataSource.filter(row => {
                if (row.isNewRow) return true; // keep the editing row visible
                return (
                    row.status?.toLowerCase().includes(query) ||
                    row.uprId?.toString().toLowerCase().includes(query) ||
                    row.uprName?.toLowerCase().includes(query) ||
                    row.placementId?.toString().toLowerCase().includes(query) ||
                    row.placementName?.toLowerCase().includes(query) ||
                    row.zone?.toString().toLowerCase().includes(query)
                );
            });

        // Force new/editing rows to the bottom
        const editingRows = searched.filter(row => row.isNewRow === true);
        const normalRows = searched.filter(row => row.isNewRow !== true);
        return [...normalRows, ...editingRows];
    }, [dataSource, searchText]);

    const tableSummary = React.useMemo(() => {
        const summary = { total: 0, enabled: 0, archived: 0 };
        dataSource?.forEach(row => {
            if (row.isNewRow) return;
            summary.total += 1;
            if (row.status === "enabled") summary.enabled += 1;
            else summary.archived += 1;
        });
        return summary;
    }, [dataSource]);

    /* ---------------------------------------------------------------------------------------
     * EXPORT
     * ------------------------------------------------------------------------------------- */
    const handleExport = () => {
        const rowsToExport = dataSource.filter(row => !row.isNewRow && !row.isEditing);
        if (!rowsToExport.length) {
            notifyfailure("No data available to export");
            return;
        }

        try {
            const exportData = rowsToExport.map(row => ({
                "Status": row.status === "enabled" ? "Enabled" : "Archived",
                "UPR ID": isEmpty(row.uprId) ? "" : row.uprId,
                "UPR Name": isEmpty(row.uprName) ? "" : row.uprName,
                "Placement ID": isEmpty(row.placementId) ? "" : row.placementId,
                "Placement Name": isEmpty(row.placementName) ? "" : row.placementName,
                "Zone": isEmpty(row.zone) ? "" : row.zone,
                "Configured amount (£)": isEmpty(row.configuredAmount) ? "" : row.configuredAmount,
                "Expected amount ($)": isEmpty(row.expectedAmount) ? "" : row.expectedAmount,
                "Variance (£)": isEmpty(row.variance) ? "" : row.variance,
            }));

            const ws = XLSX.utils.json_to_sheet(exportData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "UPR");

            const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
            saveAs(
                new Blob([wbout], { type: "application/octet-stream" }),
                "upr_" + new Date().getTime() + ".xlsx"
            );
        } catch (error) {
            notifyfailure("Failed to export UPR list");
        }
    };

    /* ---------------------------------------------------------------------------------------
     * IMPORT (bulk upload via Excel)
     * ------------------------------------------------------------------------------------- */
    // Headers must match the upload template exactly — all six are mandatory.
    const REQUIRED_HEADERS = [
        "UPR Id",
        "UPR Name",
        "Placement Id",
        "Placement Name",
        "Configured Amount GBP",
        "Expected Amount USD",
    ];

    // Download a ready-to-fill template with the required headers + one example row.
    const handleSampleDownload = () => {
        const token = Cookies.get("token_xapads_ssp");
        axios
            .get(configData.SERVER_URL + `upr-placement/sample-excel`, {
                headers: { "x-access-token": token },
                responseType: "blob",
            })
            .then((response) => {
                const blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                saveAs(blob, "upr_upload_sample.xlsx");
            })
            .catch(() => {
                notifyfailure("Failed to download the sample template");
            });
    };

    // Parse + validate the file locally. On success, keep the original file so it
    // can be sent to the server untouched; on failure, surface the reason as a toast.
    const handleFileSelect = (e) => {
        const file = e.target.files?.[0];
        // Reset so selecting the same file again still fires onChange.
        e.target.value = "";
        if (!file) return;

        const name = file.name?.toLowerCase() || "";
        if (!name.endsWith(".xlsx") && !name.endsWith(".xls")) {
            notifyfailure("Unsupported file format. Please upload an Excel (.xlsx) file.");
            return;
        }
        // if (file.size / (1024 * 1024) >= 5) {
        //     notifyfailure("File must be less than 5 MB in size.");
        //     return;
        // }

        const reader = new FileReader();

        reader.onload = (evt) => {
            try {
                const data = new Uint8Array(evt.target.result);
                const wb = XLSX.read(data, { type: "array" });
                const ws = wb.Sheets[wb.SheetNames[0]];
                const rows = XLSX.utils.sheet_to_json(ws, { defval: "" });

                if (!rows.length) {
                    notifyfailure("The uploaded file has no data rows.");
                    return;
                }

                // Every required header must be present.
                const presentHeaders = Object.keys(rows[0]);
                const missing = REQUIRED_HEADERS.filter(h => !presentHeaders.includes(h));
                if (missing.length) {
                    notifyfailure(`Missing required column(s): ${missing.join(", ")}`);
                    return;
                }

                // Validate every row against the same rules used in the table.
                const rowErrors = [];
                const seenUprIds = new Set();

                rows.forEach((r, idx) => {
                    const excelRow = idx + 2; // +1 for header, +1 for 1-based rows
                    const mapped = {
                        uprId: r["UPR Id"]?.toString().trim(),
                        uprName: r["UPR Name"]?.toString().trim(),
                        placementId: r["Placement Id"]?.toString().trim(),
                        placementName: r["Placement Name"]?.toString().trim(),
                        configuredAmount: r["Configured Amount GBP"]?.toString().trim(),
                        expectedAmount: r["Expected Amount USD"]?.toString().trim(),
                    };

                    const errors = validateRow(mapped);
                    if (Object.keys(errors).length) {
                        rowErrors.push(`Row ${excelRow}: ${Object.values(errors).join(", ")}`);
                        return;
                    }

                    // Duplicate UPR IDs within the same file aren't allowed.
                    if (seenUprIds.has(mapped.uprId)) {
                        rowErrors.push(`Row ${excelRow}: Duplicate UPR ID "${mapped.uprId}" in file`);
                        return;
                    }
                    seenUprIds.add(mapped.uprId);
                });

                if (rowErrors.length) {
                    const preview = rowErrors.slice(0, 5).join(" | ");
                    const extra = rowErrors.length > 5 ? ` …and ${rowErrors.length - 5} more` : "";
                    notifyfailure2(preview + extra);
                    return;
                }

                // Validation passed — keep the original file to upload as-is.
                setSelectedFile({ data: file, filename: file.name, size: file.size });
            } catch (err) {
                notifyfailure("Failed to read the file. Please upload a valid Excel file.");
            }
        };

        reader.onerror = () => notifyfailure("Failed to read the file. Please try again.");
        reader.readAsArrayBuffer(file);
    };

    // Close the dropdown, clear the staged file, and lift the page overlay.
    const closeUploadDropdown = () => {
        setUploadShow(false);
        setSelectedFile(null);
        document.querySelector(".tagging_filter_overlay")?.classList.remove("active");
    };

    // Open/close the dropdown and toggle the page overlay. Closing resets the file.
    const handleUploadToggle = () => {
        if (uploading) return; // don't close mid-upload
        const next = !uploadShow;
        setUploadShow(next);
        document.querySelector(".tagging_filter_overlay")?.classList.toggle("active", next);
        if (!next) setSelectedFile(null);
    };

    // Send the validated Excel file to the server as multipart/form-data.
    const handleSubmitUpload = () => {
        if (!selectedFile) {
            notifyfailure("Please upload a file before submitting.");
            return;
        }

        const token = Cookies.get("token_xapads_ssp");
        const formData = new FormData();
        formData.append("file", selectedFile.data);

        setUploading(true);
        setLoading(true);

        axios
            .post(configData.SERVER_URL + `upr-placement/price-upload`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "x-access-token": token,
                },
            })
            .then((response) => {
                notifysuccess(response.data.message || "UPR data uploaded successfully");
                setUploading(false);
                getData();
                closeUploadDropdown();

            })
            .catch((error) => {
                setUploading(false);
                setLoading(false);
                if (error?.response?.data?.message) notifyfailure(error.response.data.message);
                else notifycatch();
            });
    };

    const handleDiscardUpload = () => {
        if (uploading) return;
        closeUploadDropdown();
    };

    /* ---------------------------------------------------------------------------------------
     * COLUMNS
     * ------------------------------------------------------------------------------------- */
    // Treat null / undefined / empty string as "no value" (0 is a real value).
    const isEmpty = value =>
        value === null || value === undefined || value.toString().trim() === "";

    // Read-only display fallback — show a dash when there's no value.
    const showValue = value => (isEmpty(value) ? "—" : value);

    // While a row shows inputs, trim the cell's vertical padding so the field
    // sits flush and the text isn't visually offset.
    const editCellProps = (record) =>
        record.isNewRow
            ? { style: { paddingTop: '0.4rem', paddingBottom: '0.4rem', paddingLeft: "0.8rem" } }
            : {};

    const columns = [
        {
            title: "",
            dataIndex: "action",
            onCell: editCellProps,
            fixed: 'left',
            // Fixed width + fixed padding holds both the edit icon and the
            // save/cancel pair, so opening an edit doesn't shift the columns.
            width: 40,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            // onCell: () => ({ style: { paddingLeft: 12, paddingRight: 12 } }),
            // onHeaderCell: () => ({ style: { paddingLeft: 12, paddingRight: 12 } }),
            render: (_, record) =>
                record.isNewRow || record.isEditing ? (
                    <div className='d-flex align-items-center justify-content-start'
                        style={{ gap: '0.4rem' }}
                    >
                        <Tooltip title="Save">
                            <div
                                className={`div_of_icon --save_icon_div cursor_pointer ${!isRowValid(record) ? "disabled" : ""}`}
                                style={{ opacity: !isRowValid(record) ? "0.5" : "1" }}
                                onClick={() => {
                                    if (!isRowValid(record)) return;
                                    handleSave(record.key);
                                }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                    <path d="M11.6663 3.5L5.24967 9.91667L2.33301 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                        </Tooltip>
                        <Tooltip title="Discard">
                            <div className='div_of_icon --cancel_icon_div cursor_pointer' onClick={() => handleCancel(record.key)}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                    <path d="M10.5 3.5L3.5 10.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M3.5 3.5L10.5 10.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                        </Tooltip>
                    </div>
                ) : (
                    <Tooltip title="Edit">
                        <div
                            className='upr_mapper_table__edit-action cursor_pointer'
                            onClick={() => handleEdit(record.key)}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M9.33333 1.33333L12 4L4.66667 11.3333H2V8.66667L9.33333 1.33333Z" stroke="#64748B" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M2 14.6667H14" stroke="#64748B" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                    </Tooltip>
                )
        },
        {
            title: "Status",
            dataIndex: "status",
            // onCell: editCellProps,
            fixed: 'left',
            width: 110,

            render: (value, record) =>
                record.isNewRow ? (
                    // Status isn't part of the create payload — new rows are active by default.
                    // <span className="upr_status_tag --enabled">—</span>
                    <></>
                ) : (
                    // Independent of edit — changing it persists immediately via PATCH.

                    <Select
                        className={`form_select badge_content--${value === "enabled" ? "approved" : "archived"}`}
                        // className="modal_select_tag_cls"
                        style={{ width: "80%" }}
                        dropdownStyle={{
                            width: '12rem'
                        }}
                        value={value}
                        options={[
                            { label: "Enabled", value: "enabled" },
                            { label: "Archived", value: "archived" },
                        ]}
                        onChange={v => handleChangeStatus(record, v)}
                        suffixIcon={
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M4 6L8 10L12 6" stroke="#98A2B3" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        }
                    />

                )
        },
        {
            title: "UPR ID",
            dataIndex: "uprId",
            onCell: editCellProps,
            fixed: 'left',
            width: 130,
            sorter: (a, b) => {
                if (a.isNewRow || b.isNewRow) return 0;
                return (a.uprId || "").localeCompare(b.uprId || "");
            },
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (value, record) =>
                record.isNewRow ? (
                    <Input
                        placeholder="Enter UPR ID"
                        value={value}
                        className='form_control basic h_31'
                        onChange={e => handleChange(record.key, "uprId", e.target.value.replace(/\D/g, ""))}
                    />
                ) : (
                    <span className="lines_readonly">{showValue(value)}</span>
                )
        },
        {
            title: "UPR Name",
            dataIndex: "uprName",
            onCell: editCellProps,
            width: 220,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value, record) =>
                record.isNewRow || record.isEditing ? (
                    <Input
                        placeholder="Enter UPR Name"
                        value={value}
                        className='form_control basic h_31'
                        onChange={e => handleChange(record.key, "uprName", e.target.value)}
                    />
                ) : (
                    <span className="lines_readonly">
                        {value?.length >= 32 ?
                            <Tooltip title={value}><>{value?.slice(0, 32)}...</></Tooltip> :
                            <>{showValue(value)}</>}
                    </span>
                )
        },
        {
            title: "Placement ID",
            dataIndex: "placementId",
            onCell: editCellProps,
            width: 150,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value, record) =>
                record.isNewRow || record.isEditing ? (
                    <Input
                        placeholder="Enter Placement ID"
                        value={value}
                        className='form_control basic h_31'
                        onChange={e => handleChange(record.key, "placementId", e.target.value.replace(/\D/g, ""))}
                    />
                ) : (
                    <span className="lines_readonly">{showValue(value)}</span>
                )
        },
        {
            title: "Placement Name",
            dataIndex: "placementName",
            onCell: editCellProps,
            width: 240,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value, record) =>
                record.isNewRow || record.isEditing ? (
                    <Input
                        placeholder="Enter Placement Name"
                        value={value}
                        className='form_control basic h_31'
                        onChange={e => handleChange(record.key, "placementName", e.target.value)}
                    />
                ) : (
                    <span className="lines_readonly">
                        {value?.length >= 32 ?
                            <Tooltip title={value}><>{value?.slice(0, 32)}...</></Tooltip> :
                            <>{showValue(value)}</>}
                    </span>
                )
        },
        {
            title: "Zone",
            dataIndex: "zone",
            // onCell: editCellProps,
            width: 120,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            // Zone is computed server-side — not editable in create/edit.
            render: (value, record) =>
                record.isNewRow || isEmpty(value) ? (
                    <span className="lines_readonly">—</span>
                ) : Number(value) > 0 ? (
                    // Clickable only when there are zones — opens the zone listing in a new
                    // tab pre-filtered on this row's UPR Category (upr_id).
                    <Link
                        to={`/zoneList?uprCategory=${encodeURIComponent(record.uprId)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text_primary upr_zone_link"
                    >{value}</Link>
                ) : (
                    <span className="lines_readonly text_primary" style={{ textDecorationLine: "none", cursor: "default" }}>{value}</span>
                )
        },
        {
            title: "Configured amount £",
            dataIndex: "configuredAmount",
            onCell: editCellProps,
            width: 180,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value, record) =>
                record.isNewRow || record.isEditing ? (
                    <Input
                        placeholder="0.00"
                        prefix="£"
                        value={value}
                        // Red border for a non-required error (e.g. not greater than 0).
                        className={`form_control --prefix_width_remove_cls basic h_31 ${record.errors?.configuredAmount && !isEmpty(value) ? "error" : ""}`}
                        onChange={e => handleChange(record.key, "configuredAmount", sanitizeAmount(e.target.value))}
                    />
                ) : (
                    <span className="lines_readonly">{isEmpty(value) ? "—" : `£ ${value}`}</span>
                )
        },
        {
            title: "Expected amount $",
            dataIndex: "expectedAmount",
            onCell: editCellProps,
            width: 170,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value, record) =>
                record.isNewRow || record.isEditing ? (
                    <Input
                        placeholder="0.00"
                        prefix="$"
                        value={value}
                        // Red border for a non-required error (e.g. not greater than 0).
                        className={`form_control --prefix_width_remove_cls basic h_31 ${record.errors?.expectedAmount && !isEmpty(value) ? "error" : ""}`}
                        onChange={e => handleChange(record.key, "expectedAmount", sanitizeAmount(e.target.value))}
                    />
                ) : (
                    <span className="lines_readonly">{isEmpty(value) ? "—" : `$ ${value}`}</span>
                )
        },
        {
            title: "Variance",
            dataIndex: "variance",
            // onCell: editCellProps,
            onHeaderCell: () => ({
                className: 'diff_border_line_clr table_diff_colors',
            }),
            onCell: () => ({
                className: "table_diff_colors_td"
            }),
            width: 150,
            // Variance is computed server-side — not editable in create/edit.
            render: (value, record) =>
                record.isNewRow ? (
                    <span className="lines_readonly"></span>
                ) :
                    isEmpty(value) ? (
                        <span className="lines_readonly">—</span>
                    ) :
                        (
                            <span className="lines_readonly">£ {value}</span>
                        )
        }
    ];

    /* ---------------------------------------------------------------------------------------
     * HISTORY COLUMNS (placeholder — sample only for now)
     * ------------------------------------------------------------------------------------- */
    const columnsHistory = [
        { title: "Timestamp", dataIndex: "timestamp", key: "timestamp", fixed: 'left', width: 180 },
        { title: "Type", dataIndex: "type", key: "type", width: 200 },
        { title: "Updated by", dataIndex: "updatedBy", key: "updatedBy", width: 200 },
        { title: "Old Value", dataIndex: "oldValue", key: "oldValue" },
        { title: "New Value", dataIndex: "newValue", key: "newValue" },
    ];

    /* ---------------------------------------------------------------------------------------
     * EMPTY STATES
     * ------------------------------------------------------------------------------------- */
    const locale = {
        emptyText:
            <>{searchText?.trim()?.length > 0 && !loading ?
                <div className='no_data_screen'>
                    <div className='text-center'>
                        <img src={errorData} className='' alt="" />
                    </div>
                </div>
                :
                loading ?
                    <div className='no_data_screen'>
                        <div className='text-center'></div>
                    </div>
                    :
                    <div className='no_data_screen'>
                        <div className='text-center'>
                            <img src={noData} className='' alt="" />
                        </div>
                    </div>
            }</>
    };

    /* ---------------------------------------------------------------------------------------
     * RENDER
     * ------------------------------------------------------------------------------------- */
    return (
        <div className="new_table_select_row_design_cls container_box--wrapper pt_header tagging_filter_related tagging_filter_overlay">
            <div className="container_box--wrapper--title d_flex justify-content-between" style={{ marginBottom: '1rem' }}>
                <h1 className="heading fw_600"> UPR Mapper </h1>
            </div>

            {/* <div className="d_flex justify_content_between w_100 mb_10">
                <div className="radios_btns --radios_btns_new">
                    <Radio.Group
                        value={tab}
                        onChange={handleTabChange}
                        className='radio_btn--group mb-0'>
                        <Radio.Button value="live">Currently Live</Radio.Button>
                        <Radio.Button value="history">History</Radio.Button>
                    </Radio.Group>
                </div>
            </div> */}

            {/* ---------------------------------- CURRENTLY LIVE ---------------------------------- */}
            <div className="container_box--form-container border-0 p-0 mb-0" style={{ opacity: tab === "live" ? "1" : "0", display: tab === "live" ? "block" : "none" }}>
                <div className="container_box--width w-100">
                    <Row gutter={16}>
                        <Col span={24}>
                            <div className="container_box--form-container mb-0">
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <div className="form_content_block--group mb-0">
                                            <div className="block-category block_category_adjustment">
                                                <div className="form_content_block--group mb-0">

                                                    {!initialLoad &&
                                                        <div className="d_flex justify_content_between w_100 mb_10">
                                                            <div className="d_flex align-items-center justify_content_between w_100">
                                                                <div className="form_content_block--group mb-0">
                                                                    <Input
                                                                        type="text"
                                                                        className="form_control basic md search_input w_table_search"
                                                                        placeholder="Search"
                                                                        value={searchText}
                                                                        // style={{ width: '40rem' }}
                                                                        onChange={e => setSearchText(e.target.value)}
                                                                    />
                                                                </div>

                                                                <div className="d_flex align-items-center upr_mapper_controls" style={{ gap: "10px", marginLeft: "10px" }}>
                                                                    <div className={uploadShow
                                                                        ? "custom_filter_design_d2 tagging_filter upr_mapper_import active"
                                                                        : "custom_filter_design_d2 tagging_filter upr_mapper_import"}>
                                                                        <Dropdown
                                                                            show={uploadShow}
                                                                            ref={uploadDropdownRef}
                                                                            onToggle={handleUploadToggle}
                                                                            autoClose={false}
                                                                        >
                                                                            <div className="position-relative hover_effec_hide_show_d2">
                                                                                <Dropdown.Toggle id="uprUploadToggle" disabled={loading}>
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                                        <g clip-path="url(#clip0_18196_55368)">
                                                                                            <path d="M9.18428 9.69004L7.00229 7.50806L4.82031 9.69004" stroke="#1E293B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                                            <path d="M7 7.50806V12.4175" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                            <path d="M11.5762 9.99381C12.1082 9.70375 12.5285 9.24478 12.7707 8.68932C13.0129 8.13387 13.0633 7.51357 12.9138 6.92632C12.7644 6.33907 12.4236 5.81832 11.9453 5.44626C11.467 5.07419 10.8784 4.87201 10.2724 4.87161H9.5851C9.41999 4.23296 9.11224 3.64006 8.685 3.13747C8.25776 2.63489 7.72215 2.23569 7.11842 1.9699C6.5147 1.70411 5.85857 1.57865 5.19938 1.60293C4.54019 1.62722 3.89507 1.80063 3.31254 2.11013C2.73001 2.41962 2.22523 2.85715 1.83613 3.38981C1.44703 3.92248 1.18376 4.53642 1.06609 5.18548C0.948418 5.83454 0.979422 6.50184 1.15677 7.13719C1.33411 7.77255 1.65318 8.35943 2.08999 8.85372" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                        </g>
                                                                                        <defs>
                                                                                            <clipPath id="clip0_18196_55368">
                                                                                                <rect width="14" height="14" fill="white" />
                                                                                            </clipPath>
                                                                                        </defs>
                                                                                    </svg>
                                                                                    Import
                                                                                </Dropdown.Toggle>
                                                                            </div>

                                                                            <Dropdown.Menu>
                                                                                <div className="tagging_filter_content" id="uprUploadShake">
                                                                                    <Row gutter={16}>
                                                                                        <Col span={24}>
                                                                                            <div className="form_content_block--group tagging_filter_input_block"
                                                                                                style={{ height: !selectedFile ? "150px" : "72px" }}>
                                                                                                <div className="tagging_filter_input">
                                                                                                    {!selectedFile ? (
                                                                                                        <>
                                                                                                            <label htmlFor="uprUploadFile" className="ant_upload_drag">
                                                                                                                <p className="upload_drag_icon">
                                                                                                                    <img src={uploadIcon} alt="upload" />
                                                                                                                </p>
                                                                                                                <p className="ant_upload_text"
                                                                                                                >
                                                                                                                    <b className="primary">Click to upload</b> or drag and drop
                                                                                                                </p>
                                                                                                                <p className="ant_upload_hint">xlxs</p>
                                                                                                            </label>
                                                                                                            <input
                                                                                                                className="form_upload d-none"
                                                                                                                type="file"
                                                                                                                id="uprUploadFile"
                                                                                                                accept=".xlsx,.xls"
                                                                                                                onChange={handleFileSelect}
                                                                                                            />

                                                                                                            <div className="tagging_filter_sample_download mb_0">
                                                                                                                <div onClick={handleSampleDownload}>
                                                                                                                    <div className="download_box">
                                                                                                                        <img src={downloadCsvIcon} alt="" />
                                                                                                                        <p
                                                                                                                            style={{ width: "auto" }}
                                                                                                                        >Download Sample Template</p>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </>
                                                                                                    ) : (
                                                                                                        <div className="ant_upload_list--item">
                                                                                                            <div className="ant_upload_list--content">
                                                                                                                <img src={FileIcon} alt="" />
                                                                                                                <div className="ant_upload_list--info">
                                                                                                                    <span className="ant_upload_list--info-name">
                                                                                                                        {selectedFile.filename?.length > 38
                                                                                                                            ? `${selectedFile.filename.slice(0, 38)}...`
                                                                                                                            : selectedFile.filename}
                                                                                                                    </span>
                                                                                                                    <span className="ant_upload_list--info-size">
                                                                                                                        {selectedFile.size / 1024 > 100
                                                                                                                            ? `${(selectedFile.size / (1024 * 1024)).toFixed(2)} MB`
                                                                                                                            : `${(selectedFile.size / 1024).toFixed(2)} KB`}
                                                                                                                    </span>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <button
                                                                                                                type="button"
                                                                                                                className="ant_upload_list--delete"
                                                                                                                disabled={uploading}
                                                                                                                onClick={() => setSelectedFile(null)}
                                                                                                            >
                                                                                                                <img src={deleteIcon} alt="delete" />
                                                                                                            </button>
                                                                                                        </div>
                                                                                                    )}
                                                                                                </div>
                                                                                            </div>
                                                                                        </Col>
                                                                                    </Row>

                                                                                    <hr />

                                                                                    <div className="d_flex justify_content_end tagging_filter_footer">
                                                                                        <div className="filter_bottom_btns_d2 text-end">
                                                                                            <button
                                                                                                className="reset --reset_btn"
                                                                                                type="button"
                                                                                                disabled={uploading}
                                                                                                onClick={handleDiscardUpload}
                                                                                            >
                                                                                                Discard
                                                                                            </button>
                                                                                            {uploading ? (
                                                                                                <button className="btn btn_primary w_fit_content loader apply" type="button">
                                                                                                    <span>Submit</span>
                                                                                                    <img src={loaderIcon} alt="" className="loader_icon" />
                                                                                                </button>
                                                                                            ) : (
                                                                                                <button className="apply" type="button" onClick={handleSubmitUpload}>
                                                                                                    Submit
                                                                                                </button>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </Dropdown.Menu>
                                                                        </Dropdown>
                                                                    </div>
                                                                    <div className="custom_filter_design_d2">
                                                                        <div className="export_btn_hover_d2">
                                                                            <Button className="export_btn_d2"
                                                                                onClick={handleExport}
                                                                                icon={
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                                        <path d="M12.25 8.75V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V8.75" stroke="#1E293B" strokeWidth="1.54" strokeLinecap="round" strokeLinejoin="round" />
                                                                                        <path d="M4.08423 5.83325L7.0009 8.74992L9.91756 5.83325" stroke="#1E293B" strokeWidth="1.54" strokeLinecap="round" strokeLinejoin="round" />
                                                                                        <path d="M7 8.75V1.75" stroke="#1E293B" strokeWidth="1.54" strokeLinecap="round" strokeLinejoin="round" />
                                                                                    </svg>
                                                                                }>
                                                                                Export
                                                                            </Button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }

                                                    <div className='table_content--box table_empty_screen_d2 no_data_screen_view no_data_screen_view_different_table th_fixed_vertical_line upr_mapper_table'
                                                        ref={tableWrapperRef}
                                                    >
                                                        {loading && !initialLoad &&
                                                            <div className="table_new_loader_d2">
                                                                <img src={FullLoader} className="img-fluid" alt="" />
                                                            </div>
                                                        }

                                                        {initialLoad ?
                                                            <TableLoader />
                                                            :
                                                            <>
                                                                <Table
                                                                    columns={columns}
                                                                    dataSource={filteredDataSource}
                                                                    scroll={{ x: 'max-content', y: dataSource?.length === 0 ? '0px' : 'calc(100vh - 36.9rem' }}
                                                                    pagination={false}
                                                                    locale={locale}
                                                                    showSorterTooltip={false}
                                                                />
                                                                <div className='table_button_addmore'>
                                                                    <Button
                                                                        icon={
                                                                            <svg viewBox="64 64 896 896" focusable="false" data-icon="plus" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"></path><path d="M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z"></path></svg>
                                                                        } className='add_more_btn_two --new_add_more_btn' onClick={handleAddMore}>
                                                                        Add more
                                                                    </Button>
                                                                </div>
                                                                <div className='table_row_number_with_details'>
                                                                    <span className='line_count'>{tableSummary.total} UPR </span>

                                                                    <div className='enabled_disabled_text'>
                                                                        <span className='enabled_text --green'>
                                                                            <strong>{tableSummary.enabled}</strong> Enabled
                                                                        </span>
                                                                        <span className='enabled_text --red'>
                                                                            <strong>{tableSummary.archived}</strong> Archived
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>

            {/* ---------------------------------- HISTORY ---------------------------------- */}
            <div className="table_content--box no_data_screen_view user_sync_table_v2 --history_new_table_cls"
                style={{ opacity: tab === "history" ? "1" : "0", display: tab === "history" ? "block" : "none" }}
            >
                {loading && !initialLoad &&
                    <div className="table_new_loader_d2">
                        <img src={FullLoader} className="img-fluid" alt="" />
                    </div>
                }

                {initialLoad ?
                    <div className='bg-white p-4' style={{ marginTop: '1rem', border: '0.1rem solid #e2e8f0' }}>
                        <TableLoader />
                    </div>
                    :
                    <Table
                        columns={columnsHistory}
                        dataSource={dataSourceHistory || []}
                        pagination={false}
                        showSorterTooltip={false}
                        locale={locale}
                        scroll={{ x: 'max-content', y: 'calc(100vh - 28rem' }}
                    />
                }
            </div>
        </div>
    );
};

export default UprMapper;
